<div *ngIf="type === 'contactsOLD'">
    <app-title-section [title]="'Contáctanos'" [type]="'title'">
    </app-title-section>
    <div class="w-full px-0 mt-5 md:px-5">
        <form id="contactForm" #contactForm="ngForm" autocomplete="off" [formGroup]="frmSend"
            (ngSubmit)="sendForm(contactForm, 'contact')" method="post">

            <div class="w-full bg-right bg-no-repeat bg-cover border-2 border-gray-300 shadow-md rounded-xl"
                [style.background-image]="'url('+bgImage+'.png'+')'">
                <section class="w-full px-6 py-4 mx-auto bg-white shadow-md rounded-xl bg-opacity-10">
                    <div class="hidden grid-cols-1 gap-6 mt-6 md:grid sm:grid-cols-2 md:grid-cols-3">

                        <a href="#" class="flex flex-col items-center px-4 py-3 text-3xl text-gray-700 ">
                            <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                    clip-rule="evenodd" />
                            </svg>

                            <div *ngFor="let block of brand.addressBlocks; let bi = index" class="w-full"
                                [class.mt-2]="bi === 0"
                                [class.mt-6]="bi > 0"
                                [class.pt-5]="bi > 0"
                                [class.border-t]="bi > 0"
                                [class.border-gray-200]="bi > 0">
                                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                                <span *ngFor="let line of block.lines" class="block text-center md:text-xl lg:text-2xl mt-1">{{ line }}</span>
                            </div>
                        </a>

                        <a href="#" class="flex flex-col items-center px-4 py-3 text-3xl text-gray-700 ">
                            <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>

                            <div *ngFor="let block of brand.phoneBlocks; let bi = index" class="w-full"
                                [class.mt-2]="bi === 0"
                                [class.mt-6]="bi > 0"
                                [class.pt-5]="bi > 0"
                                [class.border-t]="bi > 0"
                                [class.border-gray-200]="bi > 0">
                                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                                <span *ngFor="let line of block.lines" class="block text-center md:text-xl lg:text-2xl mt-1">{{ line }}</span>
                            </div>
                        </a>

                        <a href="#" class="flex flex-col items-center px-4 py-3 text-3xl text-gray-700 ">
                            <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>

                            <div *ngFor="let block of brand.salesEmailBlocks; let bi = index" class="w-full"
                                [class.mt-2]="bi === 0"
                                [class.mt-6]="bi > 0"
                                [class.pt-5]="bi > 0"
                                [class.border-t]="bi > 0"
                                [class.border-gray-200]="bi > 0">
                                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                                <span *ngFor="let line of block.lines" class="block text-center md:text-xl lg:text-2xl mt-1">{{ line }}</span>
                            </div>
                        </a>
                    </div>

                    <div class="mt-6 ">
                        <div class="items-center -mx-2 md:flex">
                            <div class="w-full mx-2">
                                <label
                                    class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Nombre
                                    y Apellido</label>
                                <input id="txt_fullname" name="txt_fullname"
                                    class="flex w-full px-4 py-2 text-xl text-gray-800 bg-white border-2 border-gray-400 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlytexts"
                                    type="text" placeholder="Ingresa tu nombre" formControlName="fcn_fullname"
                                    class.is-invalid="invalidValue(fcn_fullname)" maxlength="50" minlength="5"
                                    appvalidation>
                                <div class="h-10">
                                    <app-forms-error [form]="frmSend" [fcn]="'fcn_fullname'" [min]="5" [max]="50"
                                        [msj]="' Por favor, ingresa tu nombre completo.'" [type]="'text'">
                                    </app-forms-error>
                                </div>
                            </div>

                            <div class="w-full mx-2 mt-4 md:mt-0">
                                <label
                                    class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Correo
                                    electrónico</label>

                                <input id="txt_email" name="txt_email"
                                    class="flex w-full px-4 py-2 text-xl text-gray-800 bg-white border-2 border-gray-400 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlyemails"
                                    type="email" placeholder="Ingresa tu correo electrónico" formControlName="fcn_email"
                                    class.is-invalid="invalidValue(fcn_email)" maxlength="" minlength="" appvalidation>
                                <div class="h-10">
                                    <app-forms-error [form]="frmSend" [fcn]="'fcn_email'" [min]="" [max]=""
                                        [msj]="'Por favor, ingresa tu correo electrónico.'" [type]="'email'">
                                    </app-forms-error>
                                </div>
                            </div>
                        </div>

                        <div class="w-full mt-4">
                            <label
                                class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Mensaje</label>
                            <textarea id="txt_message" name="txt_message"
                                class="flex w-full h-20 px-4 py-2 text-xl text-gray-800 bg-white border-2 border-gray-400 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlyalphanumerics"
                                placeholder="Tu mensaje." formControlName="fcn_message"
                                class.is-invalid="invalidValue(fcn_message)" cols="30" rows="5" maxlength="250"
                                minlength="5" appvalidation (keydown)="onKeydown($event)"></textarea>
                            <div class="h-10">
                                <app-forms-error [form]="frmSend" [fcn]="'fcn_message'" [min]="5" [max]="250"
                                    [msj]="'Por favor, escribe tu mensaje.'" [type]="'textarea'">
                                </app-forms-error>
                            </div>
                        </div>

                        <div class="flex justify-center mt-6">
                            <button
                                class="px-6 py-3 text-xl font-semibold text-white uppercase transition-colors duration-200 transform rounded-md bg-sigma-200 hover:bg-sigma-100 focus:outline-none focus:bg-sigma-100">Enviar
                                Mensaje</button>
                        </div>
                    </div>

                </section>
            </div>
            <div class="mt-5 mb-10"
                [ngClass]="submitted ?'animate__animated animate__fadeIn transform  opacity-100':'animate__animated animate__fadeOut transform  opacity-0'">
                <div class="messageSuccess" [ngClass]="messageSendingType?'messageSuccess':'messageError'">
                    <span class="msj">{{messageSending}}</span>
                </div>
            </div>
            <!-- Mobile - Address -->
            <div class="grid grid-cols-1 px-0 mt-5 md:hidden">
                <a href="#" class="flex flex-row items-start justify-start px-0 py-2 text-3xl text-gray-700 ">
                    <svg class="w-10 h-10 flex-shrink-0 mt-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                            clip-rule="evenodd" />
                    </svg>
                    <div class="flex flex-col ml-5 mt-2 w-full min-w-0">
                        <div *ngFor="let block of brand.addressBlocks; let bi = index" class="w-full"
                            [class.mt-2]="bi === 0"
                            [class.mt-6]="bi > 0"
                            [class.pt-5]="bi > 0"
                            [class.border-t]="bi > 0"
                            [class.border-gray-200]="bi > 0">
                            <span class="block text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                            <span *ngFor="let line of block.lines" class="block text-2xl text-justify mt-1">{{ line }}</span>
                        </div>
                    </div>
                </a>

                <a href="#" class="flex flex-row items-start justify-start px-0 py-2 text-3xl text-gray-700 ">
                    <svg class="w-8 h-8 flex-shrink-0 mt-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>

                    <div class="flex flex-col ml-4 mt-2 w-full min-w-0">
                        <div *ngFor="let block of brand.phoneBlocks; let bi = index" class="w-full"
                            [class.mt-2]="bi === 0"
                            [class.mt-6]="bi > 0"
                            [class.pt-5]="bi > 0"
                            [class.border-t]="bi > 0"
                            [class.border-gray-200]="bi > 0">
                            <span class="block text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                            <span *ngFor="let line of block.lines" class="block text-2xl text-justify mt-1">{{ line }}</span>
                        </div>
                    </div>
                </a>

                <a href="#" class="flex flex-row items-start justify-start px-0 py-2 text-3xl text-gray-700 ">
                    <svg class="w-10 h-10 flex-shrink-0 mt-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>

                    <div class="flex flex-col ml-5 mt-2 w-full min-w-0">
                        <div *ngFor="let block of brand.salesEmailBlocks; let bi = index" class="w-full"
                            [class.mt-2]="bi === 0"
                            [class.mt-6]="bi > 0"
                            [class.pt-5]="bi > 0"
                            [class.border-t]="bi > 0"
                            [class.border-gray-200]="bi > 0">
                            <span class="block text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                            <span *ngFor="let line of block.lines" class="block text-2xl text-justify mt-1">{{ line }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </form>
    </div>
</div>


<div *ngIf="type==='contacts'" class="mb-16">
    <app-title-section [title]="'Contáctanos'" [type]="'title'" [centered]="true">
    </app-title-section>
    <div class="hidden w-full md:flex mb-14 justify-center px-4">
        <div class="hidden mt-6 gap-8 lg:gap-14 md:grid md:grid-cols-3 md:max-w-5xl md:mx-auto md:w-full md:justify-items-center">
            <div
                class="flex flex-col items-center justify-center px-4 py-3 text-gray-600 border-4 border-gray-100 rounded-md shadow-md bg-gray-50 md:text-xl lg:text-2xl w-full max-w-sm text-center">
                <svg class="w-10 h-10 text-sigma-300 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clip-rule="evenodd" />
                </svg>
                <div *ngFor="let block of brand.addressBlocks; let bi = index" class="w-full"
                    [class.mt-2]="bi === 0"
                    [class.mt-6]="bi > 0"
                    [class.pt-5]="bi > 0"
                    [class.border-t]="bi > 0"
                    [class.border-gray-200]="bi > 0">
                    <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                    <span *ngFor="let line of block.lines" class="block text-center mt-1 md:text-xl lg:text-2xl">{{ line }}</span>
                </div>
            </div>
            <div
                class="flex flex-col items-center justify-center px-4 py-3 text-gray-600 border-4 border-gray-100 rounded-md shadow-md bg-gray-50 md:text-xl lg:text-2xl w-full max-w-sm text-center">
                <svg class="w-10 h-10 text-sigma-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path
                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <div *ngFor="let block of brand.phoneBlocks; let bi = index" class="w-full"
                    [class.mt-2]="bi === 0"
                    [class.mt-6]="bi > 0"
                    [class.pt-5]="bi > 0"
                    [class.border-t]="bi > 0"
                    [class.border-gray-200]="bi > 0">
                    <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                    <span *ngFor="let line of block.lines" class="block text-center mt-1 md:text-xl lg:text-2xl">{{ line }}</span>
                </div>
            </div>
            <div
                class="flex flex-col items-center justify-center px-4 py-3 text-gray-600 border-4 border-gray-100 rounded-md shadow-md bg-gray-50 md:text-xl lg:text-2xl w-full max-w-sm text-center">
                <svg class="w-10 h-10 text-sigma-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <div *ngFor="let block of brand.salesEmailBlocks; let bi = index" class="w-full"
                    [class.mt-2]="bi === 0"
                    [class.mt-6]="bi > 0"
                    [class.pt-5]="bi > 0"
                    [class.border-t]="bi > 0"
                    [class.border-gray-200]="bi > 0">
                    <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                    <span *ngFor="let line of block.lines" class="block text-center mt-1 md:text-xl lg:text-2xl">{{ line }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Formulario de contacto desactivado: cambiar *ngIf a true en forms.component.html para rehabilitarlo -->
    <ng-container *ngIf="false">
    <div class="flex w-full overflow-hidden bg-white border-4 border-gray-200 rounded-md shadow-md">
        <div class="hidden w-1/2 bg-no-repeat bg-cover md:block" [style.background-image]="'url('+bgImage+'.png'+')'">
        </div>
        <div class="w-full px-6 py-6 md:flex-1">
            <form id="contactForm" #contactForm="ngForm" autocomplete="off" [formGroup]="frmSend"
                (ngSubmit)="sendForm(contactForm, 'contact')" method="post">

                <div class="mt-0">
                    <label class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Nombre
                        y Apellido</label>
                    <input id="txt_fullname" name="txt_fullname"
                        class="flex w-full px-4 py-2 text-lg text-gray-800 bg-white border-2 border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlytexts"
                        type="text" placeholder="Ingresa tu nombre." formControlName="fcn_fullname"
                        class.is-invalid="invalidValue(fcn_fullname)" maxlength="50" minlength="5" appvalidation>
                    <div class="h-auto">
                        <app-forms-error [form]="frmSend" [fcn]="'fcn_fullname'" [min]="5" [max]="50"
                            [msj]="' Por favor, ingresa tu nombre completo.'" [type]="'text'">
                        </app-forms-error>
                    </div>
                </div>
                <div class="mt-6">
                    <label class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Correo
                        electrónico</label>

                    <input id="txt_email" name="txt_email"
                        class="flex w-full px-4 py-2 text-lg text-gray-800 bg-white border-2 border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlyemails"
                        type="email" placeholder="Ingresa tu correo electrónico." formControlName="fcn_email"
                        class.is-invalid="invalidValue(fcn_email)" maxlength="" minlength="" appvalidation>
                    <div class="h-auto">
                        <app-forms-error [form]="frmSend" [fcn]="'fcn_email'" [min]="" [max]=""
                            [msj]="'Por favor, ingresa tu correo electrónico.'" [type]="'email'">
                        </app-forms-error>
                    </div>
                </div>
                <div class="mt-6">
                    <label
                        class="flex mb-2 text-xl font-semibold text-gray-600 uppercase dark:text-gray-200">Mensaje</label>
                    <textarea id="txt_message" name="txt_message"
                        class="flex w-full h-20 px-4 py-2 text-lg text-gray-800 bg-white border-2 border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring apponlyalphanumerics"
                        placeholder="Tu mensaje." formControlName="fcn_message"
                        class.is-invalid="invalidValue(fcn_message)" cols="30" rows="3" maxlength="250" minlength="5"
                        appvalidation (keydown)="onKeydown($event)"></textarea>
                    <div class="h-auto">
                        <app-forms-error [form]="frmSend" [fcn]="'fcn_message'" [min]="5" [max]="250"
                            [msj]="'Por favor, escribe tu mensaje.'" [type]="'textarea'">
                        </app-forms-error>
                    </div>
                </div>
                <div class="mt-6">
                    <button [disabled]="frmSend.invalid"
                    [ngClass]="frmSend.invalid ? 'bg-gray-300 text-gray-600 cursor-default':'text-white bg-sigma-200 hover:bg-sigma-100 focus:outline-none focus:bg-sigma-100'"
                        class="w-full px-4 py-3 text-xl font-semibold tracking-wide transition-colors duration-200 transform rounded focus:outline-none ">
                        Enviar
                        Mensaje
                    </button>
                </div>
                <div class="mt-3" *ngIf="submitted"
                    [ngClass]="submitted ?'animate__animated animate__fadeIn transform  opacity-100':'animate__animated animate__fadeOut transform  opacity-0'">
                    <div class="messageSuccess" [ngClass]="messageSendingType?'messageSuccess':'messageError'">
                        <span class="text-xl msj">{{messageSending}}</span>
                    </div>
                </div>
            </form>
        </div>
    </div>
    </ng-container>

    <!-- Mobile - Address -->
    <div class="grid grid-cols-1 px-0 mt-5 md:hidden justify-items-center">
        <div class="flex flex-col items-center justify-center px-0 py-2 text-xl text-gray-700 text-center max-w-md">
            <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clip-rule="evenodd" />
            </svg>
            <div *ngFor="let block of brand.addressBlocks; let bi = index" class="w-full px-2"
                [class.mt-2]="bi === 0"
                [class.mt-6]="bi > 0"
                [class.pt-5]="bi > 0"
                [class.border-t]="bi > 0"
                [class.border-gray-200]="bi > 0">
                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                <span *ngFor="let line of block.lines" class="block text-center text-xl mt-1">{{ line }}</span>
            </div>
        </div>
        <div class="flex flex-col items-center justify-center px-0 py-2 text-xl text-gray-700 text-center max-w-md">
            <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path
                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            <div *ngFor="let block of brand.phoneBlocks; let bi = index" class="w-full px-2"
                [class.mt-2]="bi === 0"
                [class.mt-6]="bi > 0"
                [class.pt-5]="bi > 0"
                [class.border-t]="bi > 0"
                [class.border-gray-200]="bi > 0">
                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                <span *ngFor="let line of block.lines" class="block text-center text-xl mt-1">{{ line }}</span>
            </div>
        </div>
        <div class="flex flex-col items-center justify-center px-0 py-2 text-xl text-gray-700 text-center max-w-md">
            <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            <div *ngFor="let block of brand.salesEmailBlocks; let bi = index" class="w-full px-2"
                [class.mt-2]="bi === 0"
                [class.mt-6]="bi > 0"
                [class.pt-5]="bi > 0"
                [class.border-t]="bi > 0"
                [class.border-gray-200]="bi > 0">
                <span class="block text-center text-sm font-semibold uppercase tracking-wide text-sigma-300">{{ block.regionLabel }}</span>
                <span *ngFor="let line of block.lines" class="block text-center text-xl mt-1">{{ line }}</span>
            </div>
        </div>
        <br>
    </div>

</div>